import Vue from "vue";
const rules = {
  data() {
    return {
      userSelectValues: {},
    };
  },
  methods: {
    initData() {
      this.$nextTick(() => {
        this.formData.forEach((item) => {
          if (
            (item.fieldLevel == 1 ||
              item.fieldLevel == 2 ||
              item.fieldLevel == 3) &&
            item.value
          ) {
            this.valueChange(item, true);
          }
        });
      });
    },
    valueChange(obj, flag) {
      // 1有条件跳转 2 无条件跳转
      this.$emit("update:rulesJump", 0);
      if (
        !obj ||
        !obj.rulesInfo ||
        !obj.rulesInfo.rules ||
        obj.rulesInfo.rules.length == 0
      )
        return;
      this.goToByRules(obj, flag);
      //如果有值的选项被隐藏 不需要重新设置 防止用户从下往上面填数据
      obj.rulesCode = obj.rulesCode || obj.fieldName;
      this.userSelectValues[obj.rulesCode] = {
        sortBy: obj.sortBy,
        obj: obj,
        rulesCode: obj.rulesCode,
      };
      let gotoItem = null;
      for (let key in this.userSelectValues) {
        gotoItem = this.formData.find((a) => {
          return a.fieldName == this.userSelectValues[key].rulesCode;
        });
        if (
          gotoItem &&
          Number(this.userSelectValues[key].sortBy) > obj.sortBy &&
          gotoItem.isShow
        ) {
          this.goToByRules(this.userSelectValues[key].obj, flag);
        }
      }
    },
    goToByRules(obj, flag) {
      //先恢复数据以免规则相互影响
      this.recoveryData(obj.sortBy);
      if (!obj.value) return;
      if (obj.rulesInfo.rulesType == 2) {
        //日期 文件 图片都是无条件跳转
        for (let item of obj.rulesInfo.rules) {
          this.goTo(item.rulesJump, obj.sortBy, item.rulesGoto);
          break;
        }
      } else if (obj.rulesInfo.rulesType == 1) {
        for (let item of obj.rulesInfo.rules) {
          //rulesJump 1正常结束 2提前结束 3跳转到相应题目
          // rulesCondition 1等于/选中 [选中是完全等于]2包含/未选中
          // displayType：1单行 2多行 3单选 4下拉单选 5多选 6下拉多选 7 图片 8 文件  9 单选图片 10 多选图片
          if (
            obj.displayType == 1 ||
            obj.displayType == 2 ||
            obj.displayType == 3 ||
            obj.displayType == 4 ||
            obj.displayType == 5 ||
            obj.displayType == 6 ||
            obj.displayType == 9 ||
            obj.displayType == 10
          ) {
            //1等于/选中 [选中是完全等于]2包含/未选中
            if (
              obj.displayType == 5 ||
              obj.displayType == 6 ||
              obj.displayType == 10
            ) {
              if (flag) {
                obj.value = obj.ruleValue.split(",").sort().join(",");
              } else {
                obj.value = obj.value.split(",").sort().join(",");
              }
              item.rulesSelect = item.rulesSelect.split(",").sort().join(",");
            }
            if (item.rulesCondition == 1) {
              if (obj.value == item.rulesSelect) {
                this.goTo(item.rulesJump, obj.sortBy, item.rulesGoto);
                break;
              }
            } else if (item.rulesCondition == 2) {
              if (obj.displayType == 1 || obj.displayType == 2) {
                if (obj.value.indexOf(item.rulesSelect) > -1) {
                  this.goTo(item.rulesJump, obj.sortBy, item.rulesGoto);
                  break;
                }
              } else {
                if (
                  (obj.displayType == 3 ||
                    obj.displayType == 4 ||
                    obj.displayType == 9) &&
                  obj.value != item.rulesSelect
                ) {
                  this.goTo(item.rulesJump, obj.sortBy, item.rulesGoto);
                  break;
                }
                if (
                  (obj.displayType == 5 ||
                    obj.displayType == 6 ||
                    obj.displayType == 10) &&
                  obj.value.indexOf(item.rulesSelect) == -1
                ) {
                  this.goTo(item.rulesJump, obj.sortBy, item.rulesGoto);
                  break;
                }
              }
            }
          }
        }
      }
    },
    goTo(rulesJump, sortBy, rulesGoto) {
      //rulesJump 1正常结束 2提前结束 3跳转到相应题目
      this.$emit("update:rulesJump", rulesJump);
      if (rulesJump == 2) {
        this.goToEnd(sortBy);
      } else if (rulesJump == 3) {
        this.goToSelectCode(sortBy, rulesGoto);
      }
    },
    recoveryData(sortBy) {
      this.formData.forEach((item, index) => {
        if (item.sortBy > sortBy) {
          item.isShow = item.isOldShow;
          Vue.set(this.formData, index, item);
        }
      });
    },
    goToEnd(sortBy) {
      this.formData.forEach((item, index) => {
        if (item.sortBy > sortBy) {
          item.isShow = false;
          Vue.set(this.formData, index, item);
        }
      });
    },
    goToSelectCode(sortBy, rulesGoto) {
      let goItem = this.formData.find((a) => a.fieldName == rulesGoto);
      if (goItem) {
        this.formData.forEach((item, index) => {
          if (item.sortBy > sortBy && item.sortBy < goItem.sortBy) {
            item.isShow = false;
            Vue.set(this.formData, index, item);
          }
          if (item.sortBy == goItem.sortBy) {
            item.isShow = true;
            Vue.set(this.formData, index, item);
          }
        });
      }
    },
  },
};
export default rules;
